import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { AuthService } from '@app/modules/components/auth/auth.service';
import { Observable } from 'rxjs';
import { RouteRedirectService } from '../services/route-redirect.service';

@Injectable({
  providedIn: 'root',
})
export class NonAuthGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly routeRedirectService: RouteRedirectService,
  ) {}

  public canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (this.authService.isLoggedIn()) {
      return this.routeRedirectService.getRedirectUrlByRole(
        this.authService.userRole,
      );
    } else {
      return true;
    }
  }
}
